import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { assembleIssues, user } from '../ExperimentDAO';
import { Message } from "../details/entities/Message";
import { selectCurrentExperiment } from './ExperimentSlice';

export const fetchIssues = createAsyncThunk(
  'fetchIssues',
  async (experiments) => {
    return await assembleIssues(experiments)
  }
)

const initialState = {
  issues: [],
};

const issuesSlice = createSlice({
  name: 'issues',
  initialState,
  reducers: {
    issueResolved(state, action) {
      const { id, issuesKey } = action.payload

      const matchingIssue = state.issues.find(issue => issue.id === id && issue.experimentEntry.issuesKey === issuesKey)

      if (matchingIssue) {
        matchingIssue.messages.push(new Message(Date.now(), "Marked as resolved by " + user + ".").toJson())
        matchingIssue.resolved = true
      }
    },
    issueNoteAdded(state, action) {
      const { id, newNote, issuesKey } = action.payload

      const matchingIssue = state.issues.find(issue => issue.id === id && issue.experimentEntry.issuesKey === issuesKey)

      if (matchingIssue) {
        matchingIssue.messages.push(newNote.toJson());
      }
    },
    issueCreated(state, action) {
      state.issues.push(action.payload)
    },
    resetStore(state) {
      state.issues = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchIssues.fulfilled, (state, action) => {
      state.issues = action.payload
    })
  },
})

export const { issueResolved, issueNoteAdded, issueCreated, resetStore } = issuesSlice.actions

export default issuesSlice.reducer

export const selectIssues = state => state.issues.issues

export const selectOpenIssues = createSelector([selectIssues], (issues) => {
  if (issues) {
    return issues.filter(issue => !issue.resolved)
  }
})

export const selectNextIssueId = createSelector([selectIssues, selectCurrentExperiment], (issues, currentExperiment) => {
  let issuesInExperiment = issues.filter(issue => issue.experimentEntry.dataKey == currentExperiment.dataKey)
  return issuesInExperiment.length + 1
})

export const selectIssuesInExperiment = createSelector([selectIssues, selectCurrentExperiment], (issues, currentExperiment) => {
  return issues.filter(issue => issue.experimentEntry.dataKey == currentExperiment.dataKey)
})